import Controller from "../../../../core/js/Controller";

export default class Header extends Controller {
    constructor() {
        super();

        this.body = document.querySelector('body');
        this.auth = document.getElementById('modal-auth');
        this.menu = document.getElementById('modal-menu');
        this.search = document.getElementById('modal-search');
    }

    toggleSearch(e) {
        if (this.searchBtn.hasClass('open')) {
            this.closeSearch(e)
        } else {
            this.openSearch(e);
        }
    }

    toggleMenu(e) {
        if (this.menuBtn.hasClass('open')) {
            this.closeMenu(e)
        } else {
            this.openMenu(e);
        }
    }

    openSearch(e) {
        e.preventDefault();

        this.body.addClass('modal-open');
        this.searchBtn.addClass('open');

        this.search.removeClass('hidden');
        setTimeout(function () {
            this.search.addClass('open');
        }.bind(this), 1);

    }

    openMenu(e) {
        e.preventDefault();

        this.body.addClass('modal-open');
        this.menuBtn.addClass('open');

        this.menu.removeClass('hidden');
        setTimeout(function () {
            this.menu.addClass('open');
        }.bind(this), 1);
    }

    openAuth(e) {
        e.preventDefault();

        this._openAuth();
    }

    _openAuth() {
        this.body.addClass('modal-open');

        this.auth.removeClass('hidden');
        setTimeout(function () {
            this.auth.addClass('open');
        }.bind(this), 1);
    }

    closeSearch(e) {
        e.preventDefault();

        this.body.removeClass('modal-open');
        this.searchBtn.removeClass('open');

        this.search.removeClass('open');
        setTimeout(function () {
            this.search.addClass('hidden');
        }.bind(this), 300);
    }

    closeMenu(e) {
        e.preventDefault();

        this.body.removeClass('modal-open');
        this.menuBtn.removeClass('open');

        this.menu.removeClass('open');
        setTimeout(function () {
            this.menu.addClass('hidden');
        }.bind(this), 300);
    }
}